<template>
  <PageTemplate>
    <h1>Pending Approval</h1>
    <div>
      <v-card :title="currentRequest.first_name + ' ' +currentRequest.last_name">
        <template>
          <h4>
            Personal Details
            <v-button
              color="transparent"
              @click="edit"
            >
              <v-icon
                size="lg"
                type="edit"
              />
            </v-button>
          </h4>
          <v-data-list :data="personalDetails" />
        </template>
        <h4>
          Site/Facility Access Details
          <v-button
            color="transparent"
            @click="edit"
          >
            <v-icon
              size="lg"
              type="edit"
            />
          </v-button>
        </h4>
        <template v-if="currentRequest.hasOwnProperty('facilities') && currentRequest.roles.map(el=>el.id).includes(constants.NATA_ROLE_AR)">
          <div
            v-for="(access,index) in accessDetails"
            :key="index"
          >
            <v-data-list :data="access" />
          </div>
        </template>
        <template v-if="currentRequest.hasOwnProperty('roles') && currentRequest.roles.map(el=>el.id).includes(constants.NATA_ROLE_CM)">
          <h4>
            Selected Committee
            <v-button
              color="transparent"
              @click="edit"
            >
              <v-icon
                size="lg"
                type="edit"
              />
            </v-button>
          </h4>
          <v-data-list :data="committees" />
        </template>
        <template>
          <h4>
            Subscriptions
            <v-button
              color="transparent"
              @click="edit"
            >
              <v-icon
                size="lg"
                type="edit"
              />
            </v-button>
          </h4>
          <div v-if="selectedGeneralPublication.length > 0">
            <v-list
              :items="selectedGeneralPublication"
            />
          </div>
        </template>
        <v-button-group>
          <v-button
            size="lg"
            has-min-width
            @click="confirmationModal = true"
          >
            Approve
          </v-button>
          <v-button
            size="lg"
            color="danger"
            has-min-width
            @click="rejectionModal = true"
          >
            Reject
          </v-button>
        </v-button-group>
      </v-card>
      <v-button
        color="transparent"
        @click="goToOutstandingActivities()"
      >
        Cancel
      </v-button>
    </div>
    <v-modal
      v-if="confirmationModal"
      @close="closeModal"
    >
      <template #header>
        {{ isConfirmed ? 'Successful' : 'Confirmation' }}
      </template>
      <template v-if="isConfirmed">
        You have successfully approved
        {{ currentRequest.first_name }} {{ currentRequest.last_name }}’s registration
      </template>
      <template v-else>
        Are you sure you want to approve {{ currentRequest.first_name }} {{ currentRequest.last_name }}’s registration?
      </template>
      <template #footer>
        <v-button-group is-right>
          <v-button
            v-if="!isConfirmed"
            size="lg"
            has-min-width
            @click="approve"
          >
            Yes, Approve
          </v-button>
          <v-button
            :color="isConfirmed ? 'primary' : 'secondary'"
            size="lg"
            has-min-width
            @click="closeModal"
          >
            {{ isConfirmed ? 'Got it' : 'Cancel' }}
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
    <v-modal
      v-if="rejectionModal"
      @close="closeModal"
    >
      <template #header>
        Reject with a reason
        {{ isConfirmed ? 'Successful' : 'Confirmation' }}
      </template>
      <template v-if="rejectionReasonSubmitted && isConfirmed">
        You have successfully rejected
        {{ currentRequest.first_name }} {{ currentRequest.last_name }}’s registration
      </template>
      <template v-else-if="rejectionReasonSubmitted && !isConfirmed">
        You Rejected {{ currentRequest.first_name }} {{ currentRequest.last_name }}’s registration with following reason: <br>
        {{ rejectionReason }}
        <br><br>
        Are you sure you want to continue?
      </template>
      <template v-else>
        <v-fieldset
          v-model="rejectionReason"
          type="textarea"
        />
      </template>
      <template #footer>
        <v-button-group is-right>
          <v-button
            v-if="rejectionReasonSubmitted && !isConfirmed"
            size="lg"
            has-min-width
            @click="reject"
          >
            Yes, continue
          </v-button>
          <v-button
            v-if="!rejectionReasonSubmitted"
            size="lg"
            color="danger"
            has-min-width
            :is-disabled="!rejectionReason"
            @click="rejectionReasonSubmitted = true"
          >
            Reject
          </v-button>
          <v-button
            :color="isConfirmed ? 'primary' : 'secondary'"
            size="lg"
            has-min-width
            @click="closeModal"
          >
            {{ isConfirmed ? 'Got it' : 'Cancel' }}
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Card from "@/molecules/Card";
  import Icon from "@/atoms/Icon";
  import Modal from "@/atoms/Modal";
  import Button from "@/atoms/Button";
  import DataList from "@/atoms/DataList";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import List from "@/molecules/List";
  import Fieldset from "@/molecules/Fieldset";
  import {buildBreadCrumb,buildDefinitionList} from "@/common/tableFunctions"
  import {
    GET_ALL_USERS,
    GET_USER_INFO,
    REJECT_USER_REQUEST,
    APPROVE_USER_REQUEST,
    GET_USER_REQUEST
  } from "../../store/actions.type";
  import constants from "@/common/constants";
  import routes from "@/common/routes";
  import {mapState} from "vuex";

  export default {
    name: "Users",
    components: {
      "v-card": Card,
      "v-icon": Icon,
      "v-list": List,
      "v-button-group": ButtonGroup,
      "v-button": Button,
      "v-modal": Modal,
      "v-data-list": DataList,
      "v-fieldset": Fieldset,
      PageTemplate
    },
    data: () => ({
      confirmationModal: false,
      rejectionModal: false,
      rejectionReason: '',
      rejectionReasonSubmitted: false,
      isConfirmed: false,
      documents: [
        {
          title: "Specific Accreditation Criteria and Guidance",
          desc: "Testing and Calibration (ISO/IEC 17025), Human Pathology (ISO 15189)",
        }
      ],
    }),
    computed: {
      ...mapState({
        users: state => state.userRequest.users,
        registrations: state => state.userRequest.registrations
      }),
      selectedGeneralPublication:{
        get(){
          return this.currentRequest.subscriptions;
        },
        set(val){
          return val;
        }
      },
      currentRequest: function(){
        let id = this.$route.params.id;
        if(this.registrations.length > 0){
          return JSON.parse(this.registrations.filter(el => el.id == id)[0].value);
        }else{
          return [];
        }
      },
      personalDetails:function(){
        if(this.currentRequest.email){
          let details = [];
          details['User Type'] = this.currentRequest.roles.map(function(val){
            return constants.USER_ROLES.find(f => f.name == val.id).fullName
          }).join(',')
          details['First Name'] = this.currentRequest.first_name;
          details['Last Name'] = this.currentRequest.last_name || 'None';
          details['Position Title'] = this.currentRequest.title || 'None';
          details['Phone'] = this.currentRequest.mobile_number || 'None';
          details['Email'] = this.currentRequest.email;
          details['Address'] = this.currentRequest.address || 'None';
          details['Suburb'] = this.currentRequest.suburb || 'None';
          details['State'] = this.currentRequest.state || 'None';
          details['Country'] = this.currentRequest.country || 'None';
          details['Post Code'] = this.currentRequest.postcode || 'None';
          details['User ID'] = this.currentRequest.user_id || 'None';
          return buildDefinitionList(details);
        }else{
          return [];
        }
      },
      accessDetails:function(){
        if(this.currentRequest.facilities != null && this.currentRequest.facilities.length > 0){
          let facilities = [];
          for(let j in this.currentRequest.facilities) {
            let temp = [];
            temp['Facility Accreditation Number*'] = this.currentRequest.facilities[j].facility_number;
            temp['Facility Name*'] = this.currentRequest.facilities[j].facility_name;
            temp['Site Number and Site Name'] = this.currentRequest.facilities[j].sites.map(el => el.value).join(',');
            facilities.push(buildDefinitionList(temp));
          }
          return facilities;
        }else{
          return [];
        }
      },
      committees:function(){
        if(this.currentRequest.committees != null &&  this.currentRequest.committees.length > 0){
          let coms = [];
          coms['Committees'] = this.currentRequest.committees.map(el => el.value).join(',');
          return buildDefinitionList(coms);
        }else{
          return [];
        }
      },
      subscriptions:function(){
        if(this.currentRequest.hasOwnProperty('subscriptions') && this.currentRequest.subscriptions.length > 0){
          let subs = [];
          subs['Subscriptions'] = this.currentRequest.subscriptions.map(el => el.value).join(',');
          return buildDefinitionList(subs);
        }else{
          return [];
        }
      },
    },
    created() {
      this.constants = constants;
    },
    mounted() {
      this.updateBreadCrumb();
      this.getUsersRequest();
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Outstanding Activities'] = routes.ADMIN.OUTSTANDING_ACTIVITIES;
        breadcrumbs['All Pending Registrations'] = routes.ADMIN.PENDING_REGISTRATION_ALL;
        breadcrumbs['Pending Approval'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      closeModal: function () {
        this.confirmationModal = false;
        this.rejectionModal = false;
        this.rejectionReason = '';
        this.isConfirmed = false;
      },
      reject: function () {
        let params = {};
        params.status = "reject";
        params.reject_reason = this.rejectionReason;
        this.$store.dispatch(REJECT_USER_REQUEST,[this.$route.params.id,params]).then(response => {
            this.isConfirmed = true;
            this.closeModal();
            this.goToOutstandingActivities();
            this.$notify({
              title: "Success",
              text: response.message,
              type: "success"
            })
        }).catch(error => {
          this.$notify({
            title: "Error",
            text: error.response.data.message,
            type: "error"
          })
        });
      },
      approve: function () {
        let params = {};
        params.status = "approve";
        this.$store.dispatch(APPROVE_USER_REQUEST,[this.$route.params.id,params]).then(response => {
            this.isConfirmed = true;
            this.closeModal();
            this.goToOutstandingActivities();
            this.$notify({
              title: "Success",
              text: response.message,
              type: "success"
            })
        }).catch(error => {
          this.$notify({
            title: "Error",
            text: error.response.data.message,
            type: "error"
          });
        });
      },
      getUsers(){
        this.$store.dispatch(GET_ALL_USERS)
      },
      goToOutstandingActivities() {
        this.$router.push(routes.ADMIN.OUTSTANDING_ACTIVITIES);
      },
      edit() {
        this.$router.push(routes.ADMIN.EDIT_REGISTRATION + this.$route.params.id)
      },
      getUsersRequest(){
        this.$store.dispatch(GET_USER_REQUEST);
      },
    }
  }
</script>
